import { countryCurrencies } from '@libs/constants';

/**
 * Retrieves the according currency for given priceCountry
 */
export const getCurrencyForPriceCountry = (priceCountry: string): string | undefined =>
  countryCurrencies[priceCountry?.toUpperCase() as keyof typeof countryCurrencies];
